// extracted by mini-css-extract-plugin
export default {"rating":"vF-z","numberOfStars":"wF-z","count":"xF-z","barGraphSpacing":"yF-z","barGraph":"zF-z"};